import { createRouterState } from 'mobx-state-router';

// Drop-in shim for the legacy mobx-state-router v4 `RouterState` class.
// In v6, RouterState is a plain object created via createRouterState(); this
// class wraps that factory so `new RouterState(name, params, queryParams)`
// and the structural shape (`{ routeName, params, queryParams }`) keep
// working across the codebase. The few `route instanceof RouterState` checks
// still resolve correctly because the shim is a real class.
export class RouterState {
    constructor(routeName, params = {}, queryParams = {}) {
        const state = createRouterState(routeName, { params, queryParams });
        Object.assign(this, state);
    }
}

export default RouterState;
